import type { ReactNode } from 'react';
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { percentChange } from '../lib/format';

interface MetricCardProps {
  label: string;
  value: string;
  icon: ReactNode;
  current: number;
  prior: number | null;
  note: string;
  accent: 'blue' | 'teal' | 'violet' | 'amber';
}

export default function MetricCard({ label, value, icon, current, prior, note, accent }: MetricCardProps) {
  const change = percentChange(current, prior);
  return (
    <article className={`metric-card metric-${accent}`}>
      <div className="metric-card-top">
        <span className="metric-label">{label}</span>
        <span className="metric-icon">{icon}</span>
      </div>
      <strong className="metric-value">{value}</strong>
      <div className="metric-foot">
        {change === null ? (
          <span className="delta delta-muted"><Minus size={13} /> 暂无上期</span>
        ) : (
          <span className={`delta ${change >= 0 ? 'delta-up' : 'delta-down'}`}>
            {change >= 0 ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}
            {Math.abs(change).toFixed(1)}%
          </span>
        )}
        <span>{note}</span>
      </div>
    </article>
  );
}
